import * as i18n from 'i18next';

import { ProfileStore } from './ProfileStore';
import { initReactI18next } from 'react-i18next';
import { translationJa, translationEn } from 'locales';

const langResources = {
  en: {
    translation: translationEn,
  },
  ja: {
    translation: translationJa,
  },
};

const isLangAvailable = (lang: string) => {
  return Object.keys(langResources).includes(lang) ? lang : '';
};

export interface ILanguageStore {
  currentLng: string;
  lngQueryString: string;
  setLanguage(apiServiceAxiosInstance, lng: string): void;
  initialize(): Promise<void>;
}

export class LanguageStore implements ILanguageStore {
  _profileStore: ProfileStore;
  constructor(profileStore) {
    this._profileStore = profileStore;
  }

  currentLng: string = localStorage.i18nextLng || 'en';

  get lngQueryString(): string {
    return this.currentLng ? '?lng=' + this.currentLng : '';
  }

  public setLanguage(apiServiceAxiosInstance, lng: string) {
    this.currentLng = lng;
    localStorage.i18nextLng = lng;
    i18n.changeLanguage(lng, () => {});

    this._profileStore.updateProfile(apiServiceAxiosInstance, { preferredLanguage: lng }, () => {
      window.location.reload();
    });
  }

  public initialize = async () => {
    await i18n.use(initReactI18next).init({
      lng: isLangAvailable(this._profileStore.preferredLanguage ?? '') || isLangAvailable(navigator.language.slice(0, 2)) || 'en',
      debug: false,
      resources: langResources,
      fallbackLng: 'en',
      interpolation: { escapeValue: false },
    });
  };
}

export default LanguageStore;
